import api from '../../../services/api';

// PM Analitik Faz 2 (spec §8) — E18 "Performansım" veri katmanı. Tek birleşik uç (spec K8):
//   GET v1/performance-workspace/me?periodId=
//     → { period, periods[], nextDueAt, nextDueSource (task|window),
//         kpis { openMandatoryTasks, goalAchievement { value, source (evaluated|live), goalsWithData, goalsTotal },
//                developmentActions? { hasActivePlan, completed, total, value } (TD yoksa null), lastMeetingAt },
//         primaryTask? { taskId, taskKey, stageKey, status, dueAt, daysLeft, overdue, link },
//         otherTasks[] (Gelen Kutum öğeleri), otherTasksTotal, goals[] { id, title, goalType, status, weightPct, progressPct,
//         lastProgressAt, isStale }, nextMeetingAt, developmentActions?[] (TD yoksa null),
//         result { published, scoringEnabled, finalLevelLabel?, systemAScore?, weightedOverall?, acknowledgement?,
//                  objectionWindowEndsAt?, objectionWindowOpen } }
// Kimlik oturumdan çözülür; uç başka kişi parametresi almaz. api.js GET'te reject ETMEZ — hata sinyali res.data.status
// ("yüklenemedi" ile "boş" ayrı durum).
export const ME_PATH = '/performance/me';
export const ME_TABS = ['summary', 'tasks', 'goals', 'meetings', 'results'];
export const GOALS_PREVIEW = 6;
export const DEVELOPMENT_PLANS_PATH = '/talent/my-development-plans';

export class WorkspaceError extends Error {}

export async function fetchMe(periodId) {
  const res = await api.get('/v1/performance-workspace/me', { params: periodId ? { periodId } : {} });
  if (!res?.data?.status) throw new WorkspaceError(res?.data?.message || 'error');
  return res.data.data;
}

// "Okudum" — mevcut tebliğ ucu (Dönem Sonuçlarım ile aynı; idempotent). Hata tostu yakalayıcıda.
export async function acknowledgeResult(periodId, counterNote) {
  try {
    const res = await api.post(`/v1/my/period-results/${periodId}/acknowledge`, { counterNote: counterNote || null });
    return !!res?.data?.status;
  } catch {
    return false;
  }
}

// Performansım sayfasının adresi (sekme, dönem, açılacak hedef). E17 "Kendi Performansım" sekmesinden de buraya gidilir.
export function meLink({ tab, period, goal } = {}) {
  const p = new URLSearchParams();
  if (tab && tab !== 'summary') p.set('tab', tab);
  if (period) p.set('period', period);
  if (goal) p.set('goal', goal);
  const s = p.toString();
  return s ? `${ME_PATH}?${s}` : ME_PATH;
}

export const taskLabel = (t, key) => t(`performance.operations.taskKey.${key}`, { defaultValue: key });
export const stageLabel = (t, key) => t(`performance.insight.stage.${key}`, { defaultValue: key });

// Birincil görevin kalan süresi (sunucunun daysLeft'i: tam gün, geçmişse negatif).
export function dueText(t, task) {
  if (!task || task.daysLeft == null) return null;
  if (task.daysLeft < 0) return t('performance.workspace.me.primary.overdueDays', { days: -task.daysLeft });
  if (task.daysLeft === 0) return t('performance.workspace.me.primary.dueToday');
  return t('performance.workspace.me.primary.daysLeft', { days: task.daysLeft });
}

// Sonuç kartında sayısal bir değer var mı (yoksa "Hedef ve görüşme odaklı dönem" açıklaması).
export const hasScore = (result) => !!result
  && (!!result.finalLevelLabel || result.systemAScore != null || result.weightedOverall != null);
